// Client 공급가 계산 더미 데이터

/**
 * 테이블 1: 환율 설정 목록 조회
 */
export const exchangeRatesDummyData = {
  success: true,
  data: {
    exchangeRates: [
      {
        id: '1',
        from: 'THB',
        to: 'KRW',
        tax: 'Tax 7%',
        rate: '46.0000',
        markup: '30',
        rounding: '만원단위',
        base: '400,000',
        sendingFee: '50,000',
        additionalFee: '50,000',
        total: '1,500,000'
      },
      {
        id: '2',
        from: 'VND',
        to: 'KRW',
        tax: 'Tax 10%',
        rate: '0.0580',
        markup: '30',
        rounding: '만원단위',
        base: '400,000',
        sendingFee: '50,000',
        additionalFee: '50,000',
        total: '1,500,000'
      },
      {
        id: '3',
        from: 'MYR',
        to: 'KRW',
        tax: 'Tax 8%',
        rate: '355.0000',
        markup: '30',
        rounding: '만원단위',
        base: '400,000',
        sendingFee: '50,000',
        additionalFee: '50,000',
        total: '1,500,000'
      },
      {
        id: '4',
        from: 'SGD',
        to: 'KRW',
        tax: 'No Tax',
        rate: '200.0000',
        markup: '30',
        rounding: '만원단위',
        base: '400,000',
        sendingFee: '150,000',
        additionalFee: '50,000',
        total: '1,500,000'
      },
      {
        id: '5',
        from: 'THB',
        to: 'THB',
        tax: 'No Tax',
        rate: '1.0000',
        markup: '30',
        rounding: '백원단위',
        base: '10,000',
        sendingFee: '1,200',
        additionalFee: '1,200',
        total: '50,000'
      },
      {
        id: '6',
        from: 'USD',
        to: 'KRW',
        tax: 'No Tax',
        rate: '1,500.0000',
        markup: '30',
        rounding: '만원단위',
        base: '400,000',
        sendingFee: '50,000',
        additionalFee: '50,000',
        total: '1,500,000'
      }
    ]
  }
};

/**
 * 테이블 2: 예상 계산기 데이터
 */
export const estimateCalculatorDummyData = {
  success: true,
  data: {
    estimates: [
      {
        id: '1',
        startCurrency: 'THB',
        localVAT: 'Tax 7%',
        arrivalCurrency: 'KRW',
        exchangeRate: '45.0000',
        markup: '30',
        minMargin: '₩400,000 ~ ₩1,500,000',
        rateCard: '',
        kolTotal: 'THB 0',
        companyProfit: 'KRW 0',
        clientQuote: 'KRW 0',
        profitRate: '0'
      },
      {
        id: '2',
        startCurrency: 'VND',
        localVAT: 'Tax 10%',
        arrivalCurrency: 'KRW',
        exchangeRate: '0.0600',
        markup: '30',
        minMargin: '₩400,000 ~ ₩1,500,000',
        rateCard: '',
        kolTotal: 'VND 0',
        companyProfit: 'KRW 0',
        clientQuote: 'KRW 0',
        profitRate: '0'
      },
      {
        id: '3',
        startCurrency: 'MYR',
        localVAT: 'Tax 8%',
        arrivalCurrency: 'KRW',
        exchangeRate: '350.0000',
        markup: '30',
        minMargin: '₩400,000 ~ ₩1,500,000',
        rateCard: '',
        kolTotal: 'MYR 0',
        companyProfit: 'KRW 0',
        clientQuote: 'KRW 0',
        profitRate: '0'
      },
      {
        id: '4',
        startCurrency: 'SGD',
        localVAT: 'No Tax',
        arrivalCurrency: 'KRW',
        exchangeRate: '222.0000',
        markup: '30',
        minMargin: '₩400,000 ~ ₩1,500,000',
        rateCard: '',
        kolTotal: 'SGD 0',
        companyProfit: 'KRW 0',
        clientQuote: 'KRW 0',
        profitRate: '0'
      },
      {
        id: '5',
        startCurrency: 'THB',
        localVAT: 'No Tax',
        arrivalCurrency: 'THB',
        exchangeRate: '1.0000',
        markup: '30',
        minMargin: '₩10,000 ~ ₩50,000',
        rateCard: '',
        kolTotal: 'THB 0',
        companyProfit: 'THB 0',
        clientQuote: 'THB 0',
        profitRate: '0'
      },
      {
        id: '6',
        startCurrency: 'USD',
        localVAT: 'No Tax',
        arrivalCurrency: 'KRW',
        exchangeRate: '1,450.0000',
        markup: '30',
        minMargin: '₩400,000 ~ ₩1,500,000',
        rateCard: '',
        kolTotal: 'USD 0',
        companyProfit: 'KRW 0',
        clientQuote: 'KRW 0',
        profitRate: '0'
      }
    ]
  }
};

/**
 * 테이블 3: 개별 클라이언트 계산 설정
 */
export const clientSettingsDummyData = {
  success: true,
  data: {
    clientSettings: [
      {
        id: '1',
        name: 'bblent',
        currency: '',
        markup: '',
        rounding: '',
        base: '',
        sendingFee: '',
        additionalFee: '',
        total: '',
        active: false
      },
      {
        id: '2',
        name: 'tripleberry',
        currency: '',
        markup: '',
        rounding: '',
        base: '',
        sendingFee: '',
        additionalFee: '',
        total: '',
        active: false
      },
      {
        id: '3',
        name: 'vndoberry',
        currency: '',
        markup: '',
        rounding: '',
        base: '',
        sendingFee: '',
        additionalFee: '',
        total: '',
        active: false
      },
      {
        id: '4',
        name: 'rocoders',
        currency: '',
        markup: '',
        rounding: '',
        base: '',
        sendingFee: '',
        additionalFee: '',
        total: '',
        active: false
      },
      {
        id: '5',
        name: 'bbmarugem',
        currency: '',
        markup: '',
        rounding: '',
        base: '',
        sendingFee: '',
        additionalFee: '',
        total: '',
        active: false
      },
      {
        id: '6',
        name: 'sevenrico',
        currency: '',
        markup: '',
        rounding: '',
        base: '',
        sendingFee: '',
        additionalFee: '',
        total: '',
        active: false
      },
      {
        id: '7',
        name: 'bbmarugemth',
        currency: '',
        markup: '',
        rounding: '',
        base: '',
        sendingFee: '',
        additionalFee: '',
        total: '',
        active: false
      },
      {
        id: '8',
        name: 'bbmarugemy',
        currency: '',
        markup: '',
        rounding: '',
        base: '',
        sendingFee: '',
        additionalFee: '',
        total: '',
        active: false
      },
      {
        id: '9',
        name: 'turisun',
        currency: 'KRW',
        markup: '20',
        rounding: '천원단위',
        base: '350,000',
        sendingFee: '50,000',
        additionalFee: '30,000',
        total: '1,500,000',
        active: true
      },
      {
        id: '10',
        name: 'skinfood',
        currency: '',
        markup: '',
        rounding: '',
        base: '',
        sendingFee: '',
        additionalFee: '',
        total: '',
        active: false
      },
      {
        id: '11',
        name: 'benew',
        currency: '',
        markup: '',
        rounding: '',
        base: '',
        sendingFee: '',
        additionalFee: '',
        total: '',
        active: false
      },
      {
        id: '12',
        name: 'mediheal',
        currency: 'KRW',
        markup: '20',
        rounding: '천원단위',
        base: '280,000',
        sendingFee: '50,000',
        additionalFee: '30,000',
        total: '1,500,000',
        active: true
      },
      {
        id: '13',
        name: 'elr',
        currency: '',
        markup: '',
        rounding: '',
        base: '',
        sendingFee: '',
        additionalFee: '',
        total: '',
        active: false
      },
      {
        id: '14',
        name: 'prm',
        currency: 'KRW',
        markup: '25',
        rounding: '천원단위',
        base: '350,000',
        sendingFee: '50,000',
        additionalFee: '30,000',
        total: '1,500,000',
        active: false
      },
      {
        id: '15',
        name: 'atrezia',
        currency: '',
        markup: '',
        rounding: '',
        base: '',
        sendingFee: '',
        additionalFee: '',
        total: '',
        active: false
      },
      {
        id: '16',
        name: 'bblife',
        currency: '',
        markup: '',
        rounding: '',
        base: '',
        sendingFee: '',
        additionalFee: '',
        total: '',
        active: false
      },
      {
        id: '17',
        name: 'everymendi',
        currency: '',
        markup: '',
        rounding: '',
        base: '',
        sendingFee: '',
        additionalFee: '',
        total: '',
        active: false
      },
      {
        id: '18',
        name: 'manrible',
        currency: '',
        markup: '',
        rounding: '',
        base: '',
        sendingFee: '',
        additionalFee: '',
        total: '',
        active: false
      },
      {
        id: '19',
        name: 'kosher',
        currency: '',
        markup: '',
        rounding: '',
        base: '',
        sendingFee: '',
        additionalFee: '',
        total: '',
        active: false
      },
      {
        id: '20',
        name: 'TN',
        currency: 'THB',
        markup: '30',
        rounding: '백원단위',
        base: '10,000',
        sendingFee: '1,200',
        additionalFee: '1,200',
        total: '50,000',
        active: false
      },
      {
        id: '21',
        name: 'bbla',
        currency: '',
        markup: '',
        rounding: '',
        base: '',
        sendingFee: '',
        additionalFee: '',
        total: '',
        active: false
      },
      {
        id: '22',
        name: 'drb',
        currency: '',
        markup: '',
        rounding: '',
        base: '',
        sendingFee: '',
        additionalFee: '',
        total: '',
        active: false
      },
      {
        id: '23',
        name: 'blather',
        currency: '',
        markup: '',
        rounding: '',
        base: '',
        sendingFee: '',
        additionalFee: '',
        total: '',
        active: false
      }
    ]
  }
};
